import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ForgotService {

  constructor(private http:HttpClient) { }
  
  forgotPassword(username: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        
      })
    }
    return this.http.post(environment.apiUrl+'/forgot', { username },httpOptions);
  }
  resetPassword(username: string,  password: string, code: string )  {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        
      })
    }// username, password,code 
    return this.http.post(environment.apiUrl+'/reset', { username, password, code },httpOptions);   
  }
}
